module fdm.pilotPerformance {

    angular.module('fdm.pilotPerformance')
        .config(($stateProvider: ng.ui.IStateProvider, $locationProvider: ng.ILocationProvider) => {
            dg.uiRouter.StateProviderBuilderService.configure($stateProvider)
                .dashboardState('pilotOverview', 'pilot-overview',
                    'pilot/pilot-overview', {
                    options: () => <dg.actions.IQueryInvokerOptions>{
                        compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                            <dg.lists.IChartOptions>dg.lists.ChartService.getChartOptions({
                                templateUrl: '/app/src/pilot-performance/pilot-overview.html'
                            }),
                        ],
                    }
                })
                .listState('pilotTotalEvents', 'pilot-performance/pilot-total-events-details',
                    'pilot/pilot-total-events', {
                    options: () => <dg.actions.IQueryInvokerOptions>{
                        compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                            <dg.lists.IChartOptions>dg.lists.ChartService.getChartOptions({
                                templateUrl: '/app/src/pilot-performance/pilot-total-events-details.html'
                            }),
                            <dg.lists.IGridListOptions>dg.lists.ListOptionsService.getGridOptions({
                                type: 'grid',
                            })
                        ]
                    }
                })
                .listState('pilotTopEvents', 'pilot-performance/pilot-top-events-details',
                    'pilot/pilot-top-events', {
                    options: () => <dg.actions.IQueryInvokerOptions>{
                        compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                            <dg.lists.IChartOptions>dg.lists.ChartService.getChartOptions({
                                templateUrl: '/app/src/pilot-performance/pilot-top-events-details.html'
                            }),
                            <dg.lists.IGridListOptions>dg.lists.ListOptionsService.getGridOptions({
                                type: 'grid',
                            })
                        ]
                    }
                })
                .listState('pilotAirportEvents', 'pilot-performance/pilot-airport-events-details',
                    'pilot/pilot-airport-events', {
                    options: () => <dg.actions.IQueryInvokerOptions>{
                        compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                            <dg.lists.IChartOptions>dg.lists.ChartService.getChartOptions({
                                templateUrl: '/app/src/pilot-performance/pilot-top-events-per-airports-details.html'
                            }),
                            <dg.lists.IGridListOptions>dg.lists.ListOptionsService.getGridOptions({
                                type: 'grid',
                            })
                        ]
                    }
                })
                .dashboardState('pilotSelfOverview', 'pilot-dashboard',
                    'pilot/pilot-self-overview', {
                    options: () => <dg.actions.IQueryInvokerOptions>{
                        compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                            <dg.lists.IChartOptions>dg.lists.ChartService.getChartOptions({
                                templateUrl: '/app/src/pilot-performance/pilot-self-overview.html'
                            }),
                        ],
                    }
                })
                .listState('pilotSelfTotalEvents', 'pilot-performance/total-events-details',
                    'pilot/pilot-self-total-events', {
                    options: () => <dg.actions.IQueryInvokerOptions>{
                        compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                            <dg.lists.IChartOptions>dg.lists.ChartService.getChartOptions({
                                templateUrl: '/app/src/pilot-performance/pilot-total-events-details.html'
                            }),
                            <dg.lists.IGridListOptions>dg.lists.ListOptionsService.getGridOptions({
                                type: 'grid',
                            })
                        ]
                    }
                })
                .listState('pilotSelfTopEvents', 'pilot-performance/top-events-details',
                    'pilot/pilot-self-top-events', {
                    options: () => <dg.actions.IQueryInvokerOptions>{
                        compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                            <dg.lists.IChartOptions>dg.lists.ChartService.getChartOptions({
                                templateUrl: '/app/src/pilot-performance/pilot-top-events-details.html'
                            }),
                            <dg.lists.IGridListOptions>dg.lists.ListOptionsService.getGridOptions({
                                type: 'grid',
                            })
                        ]
                    }
                })
                .listState('pilotSelfAirportEvents', 'pilot-performance/airport-events-details',
                    'pilot/pilot-self-airport-events', {
                    options: () => <dg.actions.IQueryInvokerOptions>{
                        compositeDisplayers: <dg.actions.ICompositeDisplayerOptions>[
                            <dg.lists.IChartOptions>dg.lists.ChartService.getChartOptions({
                                templateUrl: '/app/src/pilot-performance/pilot-top-events-per-airports-details.html'
                            }),
                            <dg.lists.IGridListOptions>dg.lists.ListOptionsService.getGridOptions({
                                type: 'grid'
                            })
                        ]
                    }
                })

            //
        });
}